import { Component, input } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';
import { CopyStringComponent } from '../copy-string/copy-string.component';

@Component({
  selector: 'app-trace-id-contact-information',
  imports: [CopyStringComponent, GcTextComponent, IpoTranslatePipe],
  templateUrl: './trace-id-contact-information.component.html',
  styleUrl: './trace-id-contact-information.component.scss',
})
export class TraceIdContactInformationComponent {
  traceId = input.required<string>();
}
